import type { IconProps } from './IconProps';

export const CheckboxCheckedIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 10}
    height={props.height ?? 8}
    {...props}
  >
    <path
      d="M1 4L4 7L9 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
